import { createStyles, rem, Text } from "@mantine/core";
import * as React from "react";

const useStyles = createStyles(() => ({
  root: {
    width: "100%",
    maxWidth: rem(720),
    paddingBottom: rem(48),
  },

  name: {
    fontFamily: "Nanum Myeongjo, serif",
    fontSize: rem(18),
    color: "#000",
    marginBottom: rem(6),
  },

  contact: {
    fontFamily: "IBM Plex Mono, monospace",
    fontSize: rem(13),
    lineHeight: 1.75,
    color: "#000",
    marginBottom: rem(18),

    "& a": {
      color: "#000",
      textDecoration: "underline",
      textUnderlineOffset: rem(3),
    },
  },

  bio: {
    fontFamily: "IBM Plex Mono, monospace",
    fontSize: rem(13),
    lineHeight: 1.75,
    color: "#000",
    marginBottom: rem(32),
  },

  year: {
    fontFamily: "Nanum Myeongjo, serif",
    fontSize: rem(16),
    color: "#000",
    marginTop: rem(28),
    marginBottom: rem(10),
  },

  list: {
    margin: 0,
    padding: 0,
    listStyle: "none",
  },

  item: {
    fontFamily: "IBM Plex Mono, monospace",
    fontSize: rem(13),
    lineHeight: 1.75,
    color: "#000",
    marginBottom: rem(10),
  },
}));

function ItemList({ items }: { items: string[] }) {
  const { classes } = useStyles();

  return (
    <ul className={classes.list}>
      {items.map((item) => (
        <li key={item} className={classes.item}>
          {item}
        </li>
      ))}
    </ul>
  );
}

function YearSection({ year, items }: { year: string; items: string[] }) {
  const { classes } = useStyles();

  if (items.length === 0) {
    return null;
  }

  return (
    <section>
      <Text className={classes.year}>{year}</Text>
      <ItemList items={items} />
    </section>
  );
}

const events2026 = [
  "LA Zine Fest 2026, Angel City Derby Warehouse, Los Angeles, CA",
  "San Francisco Zine Fest 2026, The Hibernia, San Francisco, CA",
  "Comix Gauntlet 2026, Alabama Song, Basket Books & Art Gallery, Houston, TX",
  "Bay Area Book Festival 2026, Downtown Berkeley, Berkeley, CA",
  "Santa Rosa Zine Fest 2026, Sonoma County Library, Santa Rosa, CA",
  "Dallas Art Book Fair 2026, Dallas Contemporary, Dallas, TX",
];

const events2025 = [
  "East Bay Alternative Book and Zine Fest 2025, Brower Center, Berkeley, CA",
  "Short Run Comix & Arts Festival 2025, Seattle Design Center, Seattle, WA",
  "Et Al. Jumble, Et Al. Gallery, San Francisco, CA",
  "San Francisco Zine Fest 2025, City View by Metreon, San Francisco, CA",
  "Seattle Zine Fest 2025, Quality Flea Center, Seattle, WA",
  "Rare Books San Francisco 2025, Fort Mason, San Francisco, CA",
];

const events2024 = [
  "Zine Fest Houston 2024, Orange Show Center for Visionary Art, Houston, TX",
  "San Francisco Zine Fest 2024, City View by Metreon, San Francisco, CA",
];

const events2023 = [
  "Zine Fest Houston 2023, Orange Show Center for Visionary Art, Houston, TX",
  "TXST Zine Fest 2023, Texas State University, San Marcos, TX",
];

const events2022 = [
  "Lone Star Zine Fest 2022, Far Out Lounge, Austin, TX",
  "Zine Fest Houston 2022, Orange Show Center for Visionary Art, Houston, TX",
];

export function AboutContent() {
  const { classes } = useStyles();

  return (
    <div className={classes.root}>
      <Text className={classes.name}>Vidya Giri / ixorem</Text>
      <Text className={classes.contact} component="div">
        <a href="https://vidyagiri.com" target="_blank" rel="noreferrer">
          vidyagiri.com
        </a>
        {" | "}
        <a href="mailto:girividyas@gmail.com">girividyas@gmail.com</a>
      </Text>

      <Text className={classes.bio}>
        artist from houston, tx, living in san francisco, ca. i make comics, books, and zines exploring the small details of our world 
        through scraps of paper, code, and observational field notes on topics such as hypersaline
        ponds, postage stamps, mushrooms, and wildflowers.
      </Text>

      <YearSection year="2026" items={events2026} />
      <YearSection year="2025" items={events2025} />
      <YearSection year="2024" items={events2024} />
      <YearSection year="2023" items={events2023} />
      <YearSection year="2022" items={events2022} />
    </div>
  );
}
